<template>
    <div v-if="showEdicao">
        <IpOsEditPage :idEdicao="idEdicao" @close="showEdicao=false; showOSSelect=true" />
    </div>

    <div v-if="showOSSelect">
        <IpOsPesquisaPage
            :idSituacao="1"
            :idSituacao2="3"
            :idSituacao3="5"
            @cancel="cancelForm"
            @select="selecionarOS" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import IpOsEditPage from './IpOsEditPage.vue';
import IpOsPesquisaPage from './IpOsPesquisaPage.vue';

const emit = defineEmits(['close']);

const idEdicao = ref(null);
const showEdicao = ref(false);
const showOSSelect = ref(true);

const cancelForm = () => {emit('close');};

const selecionarOS = (os) => {
    showOSSelect.value      = false;
    idEdicao.value          = os.id;
    showEdicao.value=true;
};
</script>